import React from 'react';
import {
  AddOutlined as AddIcon,
  UploadOutlined as UploadIcon,
  FileDownloadOutlined as DownloadIcon,
} from '@mui/icons-material';
import { useInventoryActionButtons } from './ActionButtons.hooks';
import {
  ActionButtonsContainer,
  ButtonsWrapper,
  AddButton,
  SecondaryButton,
  HiddenButton,
} from './ActionButtons.styles';

export interface ActionButtonsProps {
  onAddRecord: () => void;
  onImport: () => void;
  onExport: () => void;
  /** Si es false, no se muestra el botón Añadir (permisos granulares). Por defecto true. */
  showAdd?: boolean;
  /** Si es false, no se muestra Exportar. Por defecto true. */
  showExport?: boolean;
  /** Deshabilita Exportar mientras la exportación está en curso. Por defecto false. */
  exportDisabled?: boolean;
  /** Texto del botón Exportar (p. ej. "Exportando..." mientras se descarga). */
  exportLabel?: string;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onAddRecord,
  onImport,
  onExport,
  showAdd = true,
  showExport = true,
  exportDisabled = false,
  exportLabel = 'Exportar',
}) => {
  const { handleAddRecord, handleImport, handleExport } = useInventoryActionButtons({
    onAddRecord,
    onImport,
    onExport,
  });

  return (
    <ActionButtonsContainer>
      <ButtonsWrapper>
        {showAdd && (
          <AddButton
            variant="contained"
            startIcon={<AddIcon />}
            size="small"
            onClick={handleAddRecord}
            sx={{
              background: 'linear-gradient(to right, #06b6d4, #10b981)',
              color: 'white',
              '&:hover': { background: 'linear-gradient(to right, #0891b2, #059669)' },
            }}
          >
            Añadir
          </AddButton>
        )}

        {/* Botón Importar - Oculto temporalmente, se puede restaurar en el futuro */}
        <HiddenButton
          variant="outlined"
          startIcon={<UploadIcon />}
          size="small"
          onClick={handleImport}
        >
          Importar
        </HiddenButton>

        {showExport && (
          <SecondaryButton
            variant="outlined"
            startIcon={<DownloadIcon />}
            size="small"
            onClick={handleExport}
            disabled={exportDisabled}
            sx={(theme) => ({
              borderColor: theme.palette.divider,
              color: theme.palette.text.secondary,
              backgroundColor: theme.palette.background.paper,
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
                color: theme.palette.text.primary,
                borderColor: theme.palette.text.secondary,
              },
            })}
          >
            {exportLabel}
          </SecondaryButton>
        )}
      </ButtonsWrapper>
    </ActionButtonsContainer>
  );
};

export default ActionButtons;
